import { useEffect, useState } from 'react'
import { TopBar } from './TopBar'
import { BottomNav } from './BottomNav'
import { loadArchive, todayUtc, type ArchiveEntry } from '../lib/day'
import { load } from '../lib/storage'

export function Archive() {
  const [days, setDays] = useState<ArchiveEntry[] | null>(null)
  useEffect(() => { loadArchive(todayUtc()).then(setDays) }, [])
  const s = load()
  return (
    <div className="screen">
      <TopBar />
      <h1 style={{ fontSize: 28, margin: '18px 0 4px' }}>History</h1>
      <p className="muted" style={{ margin: 0 }}>Your history — every pack, every score.</p>
      {days == null ? <p className="muted">Loading…</p> : days.length === 0 ? <p className="muted" style={{ marginTop: 20 }}>No past days yet — come back tomorrow.</p> : (
        <ul className="list">
          {days.map((d) => { const r = s.results[d.date]; return (
            <a key={d.date} href="#/stats"><span className="em">{d.theme.emoji}</span><span><div>#{d.number} · {d.theme.name}</div><div className="d">{d.date}</div></span><span className="s">{r ? r.score.toLocaleString('en-US') : '—'}</span></a>
          ) })}
        </ul>
      )}
      <BottomNav />
    </div>
  )
}
